var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('Navigation'),_c('div',{staticClass:"home"},[_c('Carousel',{attrs:{"images":_vm.content.images}}),_c('MainText',{attrs:{"text":_vm.content.intro}}),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }